import {
  OverflowTooltip,
  type TestResultsTableData,
} from '@elementary/common-ui/components';
import dateRenderer from '@elementary/common-ui/components/cellRenderers/dateRenderer';
import statusFilterRenderer from '@elementary/common-ui/components/cellRenderers/statusFilterRenderer';
import { statusValueRenderer } from '@elementary/common-ui/components/cellRenderers/statusRenderer';
import { testNameValueRenderer } from '@elementary/common-ui/components/cellRenderers/testNameRenderer';
import { Column } from '@elementary/common-ui/components/Table';
import { distinctArray } from '@elementary/common-ui/utils/common';
import dateComparer from '@elementary/common-ui/utils/comparers/dateComparer';
import { statusValueComparer } from '@elementary/common-ui/utils/comparers/statusComparer';
export const getTestResultsColumns = ({
  tableData,
  showTestsFilter,
  showStatusFilter,
}: {
  tableData: TestResultsTableData[];
  showTestsFilter: boolean;
  showStatusFilter: boolean;
}): Column<TestResultsTableData>[] => {
  const testTagsFilterOptions = distinctArray(
    tableData.map((item) => item.testTags || ['']).flat(),
  ).map((item) => ({ value: item, label: item }));

  return [
    {
      id: 'columnName',
      header: 'Column name',
      filterDropdownWidth: 350,
    },
    {
      id: 'testName',
      header: 'Test name',
      renderer: ({ testName, testType, testSubType }) =>
        testNameValueRenderer(testName, testType, testSubType),
      filterable: showTestsFilter,
      nonToggleable: true,
      filterDropdownWidth: 400,
    },
    {
      id: 'testSubType',
      header: 'Test type',
    },
    {
      id: 'testTags',
      header: 'Test tags',
      renderer: (val) => (
        <OverflowTooltip>{val.testTags?.join(', ')}</OverflowTooltip>
      ),
      filterOptionsOverride: testTagsFilterOptions,
      defaultUntoggled: true,
    },
    {
      id: 'latestRunTime',
      header: 'Last test run',
      compareFunc: (a, b) => dateComparer(a.latestRunTime, b.latestRunTime),
      filterable: false,
      renderer: (val) => dateRenderer(val.latestRunTime),
    },
    {
      id: 'latestRunStatus',
      header: 'Last status',
      renderer: (val) => statusValueRenderer(val.latestRunStatus),
      compareFunc: (a, b) =>
        statusValueComparer(
          { status: a.latestRunStatus, date: a.latestRunTime },
          { status: b.latestRunStatus, date: b.latestRunTime },
        ),
      filterRenderer: statusFilterRenderer,
      filterable: showStatusFilter,
      nonToggleable: true,
      width: 160,
    },
  ];
};
